import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { GetMenu } from '../Util/Prakim';
import IconBack from "../Icons/IconBack";




const Prakim = (props) => {
  const navigate = useNavigate();
  let params = useParams();

  const [stateMenu, setStateMenu] = useState(null);

  useEffect(() => {
    setStateMenu(GetMenu(params.type));
  }, []);



  if (!stateMenu)
    return  <div className='menu'>
              <br/>
              <div className='menu-section'>
                <h4>טוען נתונים...</h4>
              </div>
            </div>;


  return (
    <div className='menu'>
        <br/>
          { 
            stateMenu.map(mi => 
              <>
                <b>{mi.name}</b>
                <div className={`menu-section ${ mi.wide && 'menu-section-wrap'}`}>
                                    { 
                    mi.prakim.map(li => {
                        return <div key={`id${li.key}`} onClick={ () => { navigate(`/pr/${params.type}/${li.key}`); window.scrollTo(0,0); } }>{li.name}</div>
                    })
                  }

                </div>
              </>
            )
          }
        <br/>
        <a className="menu-float-icon" onClick={ () => { navigate('/'); window.scrollTo(0,0); }}><IconBack /></a>
    </div>
  );
}

export default Prakim;
